import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import { AUTHORITIES } from 'app/config/constants';
import PrivateRoute from 'app/shared/auth/private-route';
import React from 'react';
import { Switch } from 'react-router-dom';
import Alert from './alert';
import AlertDeleteDialog from './alert-delete-dialog';
import AlertDetail from './alert-detail';
import { AlertUpdate } from './alert-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <PrivateRoute
        path={`${match.url}/new`}
        component={AlertUpdate}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.MANUFACTURER_ADMIN, AUTHORITIES.TRANSPORTER_ADMIN]}
      />
      <PrivateRoute
        path={`${match.url}/:id/edit`}
        component={AlertUpdate}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.MANUFACTURER_ADMIN, AUTHORITIES.TRANSPORTER_ADMIN]}
      />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AlertDetail} />
      <ErrorBoundaryRoute path={match.url} component={Alert} />
    </Switch>
    <PrivateRoute
      path={`${match.url}/:id/delete`}
      component={AlertDeleteDialog}
      hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.MANUFACTURER_ADMIN, AUTHORITIES.TRANSPORTER_ADMIN]}
    />
  </>
);

export default Routes;
